import { ApiService } from "../../../../../core";
import { DefaultResponse, DeleteAccountController } from "../../core";

export class DeleteAccountControllerImpl implements DeleteAccountController {
    private api;
    constructor() {
        this.api = new ApiService(process.env.REACT_APP_API)
    }

    async execute(formData: FormData): Promise<DefaultResponse> {
        try {
            const response = await this.api.post(`/delete-account`, formData);
            return response;
        } catch (error) {
            throw new Error(error.response.data);
        }
    }
}